import { IDWELL_TO_IDWELL_ENTITY, REQUEST_ENTITY } from '../../constants/entity'
import { callFileApi, deleteApi, getApi, postApi } from '../../utils/api'
import {
  getRequestWizardSessionHeader,
  REQUEST_WIZARD_CHUNK_PARAMS,
} from '../Request'

export function getIdwellToIdwellOutboundCompanies() {
  return getApi({
    endpoint: 'api/id2id/outbound-access-config/',
  })
}

export function getIdwellToIdwellRequestsExtraInfo(
  outboundCompanyUuid,
  params
) {
  return getApi({
    endpoint: `idwell-api/api/v3/${IDWELL_TO_IDWELL_ENTITY.single}/${outboundCompanyUuid}/${REQUEST_ENTITY.plural}/extra-info/`,
    params,
  })
}

export function getIdwellToIdwellBoundUserInfo(outboundCompanyUuid) {
  return getApi({
    endpoint: `idwell-api/api/v3/${IDWELL_TO_IDWELL_ENTITY.single}/${outboundCompanyUuid}/bound-user/`,
    params: {
      with_property_info: 1,
    },
  })
}

export function uploadIdwellToIdwellFileDocument(file, outboundUuid) {
  return callFileApi({
    data: file,
    endpoint: `api/id2id/${outboundUuid}/v2/document/`,
    method: 'POST',
  })
}

export function getIdwellToIdwellFileDocumentById(
  { id, outboundUuid },
  params
) {
  return getApi({
    endpoint: `api/id2id/${outboundUuid}/v2/document/${id}/`,
    params,
  })
}

export function getOnDeleteIdwellToIdwellFileDocument(outboundUuid) {
  return function deleteFile(id) {
    return deleteApi({
      endpoint: `api/id2id/${outboundUuid}/v2/document/${id}/`,
    })
  }
}

export function getInitIdwellToIdwellWizard(outboundUuid) {
  return function initWizard() {
    return postApi({
      endpoint: `api/id2id/${outboundUuid}/workflow/wizard/init/`,
    })
  }
}

export function getProlongIdwellToIdwellWizard(outboundUuid) {
  return function prolong(uuid) {
    return postApi({
      endpoint: `api/id2id/${outboundUuid}/workflow/wizard/prolong/`,
      headers: getRequestWizardSessionHeader(uuid),
    })
  }
}

export function getIdwellToIdwellWizardChunk(outboundUuid) {
  return function getChunk(uuid) {
    return getApi({
      endpoint: `api/id2id/${outboundUuid}/workflow/wizard/chunk/`,
      headers: getRequestWizardSessionHeader(uuid),
    })
  }
}

export function getSendIdwellToIdwellWizardPayloadChunk(outboundUuid) {
  return function sendPayloadChunk(uuid, data) {
    return postApi({
      data,
      endpoint: `api/id2id/${outboundUuid}/workflow/wizard/chunk/`,
      headers: getRequestWizardSessionHeader(uuid),
      params: REQUEST_WIZARD_CHUNK_PARAMS,
    })
  }
}

export function getIdwellToIdwellCreateRequest(outboundUuid) {
  return function createRequest(data) {
    return postApi({
      data,
      endpoint: `idwell-api/api/v3/idwell-to-idwell/${outboundUuid}/requests/`,
    })
  }
}

export function getIdwellToIdwellBuildings({ outboundUuid, ...params }) {
  return getApi({
    endpoint: `api/id2id/${outboundUuid}/building-options/`,
    params,
  })
}

export function getIdwellToIdwellFlats({ outboundUuid, ...params }) {
  return getApi({
    endpoint: `api/id2id/${outboundUuid}/flat/`,
    params,
  })
}

export function getIdwellToIdwellCategories({ outboundUuid, ...params }) {
  return getApi({
    endpoint: `api/id2id/${outboundUuid}/request-category/`,
    params,
  })
}

export function getIdwellToIdwellRequestPhase(id, outboundUuid) {
  return getApi({
    endpoint: `api/id2id/${outboundUuid}/request/${id}/pipeline/`,
  })
}

export function getIdwellToIdwellFilesAccess(outboundUuid) {
  return getApi({
    endpoint: `api/id2id/${outboundUuid}/init/`,
  })
}
